// extracted by mini-css-extract-plugin
module.exports = {"errorMsgContent":"ErrorMsg-module--errorMsgContent--2Zk7R","errorIcon":"ErrorMsg-module--errorIcon--3fEH1"};